// extracted by mini-css-extract-plugin
export default {"modal":"UsedCodeModal_modal__szb9S","modal__inner":"UsedCodeModal_modal__inner__qdryC"};